import { useMemo } from "react";

import { useMoveFolderMutation } from "@/graphql/folders/folders.hooks";

interface IUseMoveSubfolderOptions {
  onCompleted?: () => void;
  onError?: () => void;
}

interface IUseMoveSubfolderVariables {
  parentId: number;
  childrenId: number;
}

const useMoveSubfolder = ({
  onCompleted,
  onError,
}: IUseMoveSubfolderOptions) => {
  const [moveSubfolder, { loading, error }] = useMoveFolderMutation({
    context: { errorType: "local" },
    onCompleted,
    onError,
  });

  return useMemo(
    () => ({
      moveSubfolder: async ({
        parentId,
        childrenId,
      }: IUseMoveSubfolderVariables) => {
        await moveSubfolder({
          variables: {
            parentId,
            childrenId,
          },
        });
      },
      loading,
      error,
    }),
    [moveSubfolder, error, loading]
  );
};

export default useMoveSubfolder;
